import { useToast } from 'common/hooks/useToast';
import useTranslation from 'common/hooks/useTranslation';
import { useUpdatePeriodicSyncMutation } from 'common/slices/offerApi.slice';
import { useEffect, useState } from 'react';
import { useDebounce } from 'usehooks-ts';

export const useAutoSyncSwitch = (initialValue, offerSlug) => {
  const toast = useToast();
  const { t } = useTranslation('offers\\details');

  const [isActive, setIsActive] = useState(initialValue);
  const debouncedIsActive = useDebounce(isActive, 500);

  const [updatePeriodicSync, { isLoading }] = useUpdatePeriodicSyncMutation();

  useEffect(() => {
    if (isActive !== initialValue) {
      setIsActive(initialValue);
    }
  }, [initialValue]);

  useEffect(() => {
    if (debouncedIsActive !== initialValue) {
      const syncStatus = debouncedIsActive ? 'true' : 'false';
      const updateSync = async () => {
        try {
          await updatePeriodicSync({ offerSlug, syncStatus }).unwrap();
          toast.newToast(
            'positive',
            t('modals.setup-sync-state.toasts.success'),
          );
        } catch (err) {
          setIsActive(initialValue); // revert in case of error
          switch (err?.status) {
            case 400:
              toast.newToast('negative', err.data?.errors?.[0]?.detail);
              break;
            case 403:
              toast.newToast(
                'negative',
                t('modals.setup-sync-state.toasts.forbidden'),
              );
              break;
            default:
              toast.newToast(
                'negative',
                t('modals.setup-sync-state.toasts.something-wrong'),
              );
          }
        }
      };
      updateSync();
    }
  }, [debouncedIsActive]);

  return {
    isActive,
    setIsActive,
    isLoading,
  };
};
